import React from "react";
import {connect} from 'react-redux'

import styles from './MenuIconDesktop.module.scss'
import {setMenuVisible} from "../actions";

const MenuIconDesktop = (props) => {
    return (
        <div className={styles.menu_wrapper} style={{color: props.color}}>
            <div className={styles.menu} onClick={() => {
                props.setMenuVisible(true)
            }}>
                <span>MENU</span>
                <span className={styles.menu_icon}><div
                    className={styles.menu_icon_line}></div></span>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        isPageVisible: state.isPageVisible
    };
};

export default connect(mapStateToProps, { setMenuVisible })(MenuIconDesktop);